import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';

import RowText from './row-text';

type CopyUrlButtonType = {
  label: string;
  onClick: () => void;
};

const useStyles = makeStyles((theme: any) => ({
  button: {
    '@media (hover: none) and (pointer: coarse)': { minHeight: theme.spacing(5.5) }
  }
}));

const CopyUrlButton: FC<CopyUrlButtonType> = ({ label, onClick }) => {
  const classes = useStyles();
  return (
    <Button className={classes.button} onClick={onClick}>
      <RowText text={label} />
    </Button>
  );
};

export default CopyUrlButton;
